import React from 'react';
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import {
  CHANGE_REQUEST_STATUS,
  CHANGE_REQUEST_STATUS_OPTIONS,
  CUSTOMER_REPORT_STATUS_OPTIONS,
  WASTE_STATUS,
  WASTE_STATUS_OPTIONS,
} from 'domain/shared/newProject';
import { Typography, TypographyOwnProps } from '@mui/material';

const StatusField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const currentStatus = getValue();

  const color: Record<string, TypographyOwnProps['color']> = {
    [CHANGE_REQUEST_STATUS.DRAFT]: 'primary',
    [CHANGE_REQUEST_STATUS.SIGNED]: 'success',
    [CHANGE_REQUEST_STATUS.VIEWED]: 'textSecondary',
    [CHANGE_REQUEST_STATUS.SENT]: 'textSecondary',
    [CHANGE_REQUEST_STATUS.REJECTED]: 'error',
    [CHANGE_REQUEST_STATUS.APPROVED]: 'success',
    [CHANGE_REQUEST_STATUS.IN_APPROVAL]: 'warning',
    [CHANGE_REQUEST_STATUS.DECLINED]: 'warning',
    [CHANGE_REQUEST_STATUS.CANCELED]: 'error',
    [WASTE_STATUS.CANCELED]: 'error',
    [WASTE_STATUS.REGISTERED]: 'textSecondary',
    [WASTE_STATUS.COMPLETELY_DISTRIBUTED]: 'success',
    [WASTE_STATUS.PARTIALLY_DISTRIBUTED]: 'success',
  };

  const currentColor = color[currentStatus] || 'textPrimary';

  const statusOption =
    CHANGE_REQUEST_STATUS_OPTIONS[currentStatus] ||
    WASTE_STATUS_OPTIONS[currentStatus] ||
    CUSTOMER_REPORT_STATUS_OPTIONS[currentStatus] ||
    currentStatus;
  return <Typography color={currentColor}>{statusOption}</Typography>;
};
export default StatusField;
